import { makeAutoObservable, runInAction } from 'mobx';

import { client } from 'contexts/ApolloClient/apolloClient';
import { standardError } from 'global/commonMessages';
import { notificationStore } from 'global/NotificationStore';
import { manageGroupDataStore } from 'pages/Profile/components/ManageGroupDataModal/ManageGroupDataStore';
import { ADD_MEMBER_TO_GROUP } from 'pages/Profile/gql/addMemberToGroup';
import { DELETE_MEMBER_FROM_GROUP } from 'pages/Profile/gql/deleteMemberFromGroup';

class AddMembersStore {
	addMembersActive = false;
	isFromCreation = false;
	currentMembersAdded = new Map();
	groupId = '';

	constructor() {
		makeAutoObservable(this);
	}

	triggerAddMembers = (groupId, isFromCreation = false) => {
		this.isFromCreation = isFromCreation;
		this.addMembersActive = true;
		this.groupId = groupId;
	};

	addMemberToGroup = async (crewMemberId, groupId) => {
		const payload = {
			crewMemberId,
			groupsIds: [groupId],
		};
		try {
			const response = await client.mutate({
				mutation: ADD_MEMBER_TO_GROUP,
				variables: {
					input: payload,
				},
				fetchPolicy: 'no-cache',
			});

			runInAction(() => {
				this.currentMembersAdded.set(response.data.assignCrewMemberToGroups.id, {
					...response.data.assignCrewMemberToGroups,
					loading: false,
				});
			});
		} catch (e) {
			console.error(e);
			notificationStore.setNotification(standardError);
		}
	};

	deleteMemberFromGroup = async (crewMemberId, groupId) => {
		const payload = {
			crewMemberId,
			groupsIds: [groupId],
		};
		this.currentMembersAdded.set(crewMemberId, {
			...this.currentMembersAdded.get(crewMemberId),
			loading: true,
		});
		try {
			const response = await client.mutate({
				mutation: DELETE_MEMBER_FROM_GROUP,
				variables: {
					input: payload,
				},
				fetchPolicy: 'no-cache',
			});
			runInAction(() => {
				this.currentMembersAdded.delete(response.data.unAssignCrewMemberFromGroups.id);
			});
		} catch (e) {
			console.error(e);
			notificationStore.setNotification(standardError);
		}
	};

	resetAddMembersStep = () => {
		this.addMembersActive = false;
		this.isFromCreation = false;
		this.groupId = '';
		this.currentMembersAdded = new Map();
		if (manageGroupDataStore.isInCreationMode) {
			manageGroupDataStore.deactivateCreationFlow();
		}
	};
}

export const addMembersStore = new AddMembersStore();
